import { Check } from "lucide-react";

export const HotelCard = ({ hotel, selected, onClick }) => (
  <button type="button" onClick={onClick} data-testid={`hotel-select-card-${hotel.slug}`}
    className={`group relative overflow-hidden rounded-2xl border bg-white text-left transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-xl ${selected ? "ring-2 ring-[#2F5BFF] ring-offset-2" : "border-slate-200"}`}>
    <div className="relative h-28 overflow-hidden">
      <img src={`/hotels/${hotel.slug}.jpg`} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${hotel.primary_color}E6, ${hotel.secondary_color}99)` }} />
      <div className="absolute inset-0 flex items-center px-5">
        {hotel.logo_data
          ? <img src={hotel.logo_data} alt={hotel.display_name} className="h-10 max-w-[160px] object-contain" />
          : <span className="font-heading text-xl font-bold text-white drop-shadow">{hotel.display_name}</span>}
      </div>
      {selected && <span className="absolute right-3 top-3 grid h-7 w-7 place-items-center rounded-full bg-white text-[#2F5BFF]"><Check size={16} /></span>}
    </div>
    <div className="flex items-center justify-between px-5 py-3">
      <span className="text-sm font-semibold text-slate-800">{hotel.name}</span>
      <span className="flex gap-1">
        {[hotel.primary_color, hotel.secondary_color, hotel.accent_color].map((col, i) => (
          <span key={`${col}-${i}`} className="h-3 w-3 rounded-full border border-black/10" style={{ background: col }} />
        ))}
      </span>
    </div>
  </button>
);

export const HotelPicker = ({ hotels, value, onChange }) => (
  <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" data-testid="hotel-picker">
    {hotels.map((h) => <HotelCard key={h.slug} hotel={h} selected={value === h.slug} onClick={() => onChange(h.slug)} />)}
  </div>
);
